module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_gold_small.d3f6a683.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_gold_small.png
// module id = 3002
// module chunks = 11